<template>
  <div>
    <v-card dark style="border-radius:10px;">
      <v-layout row justify-space-between class="pa-3">
        <v-flex xs3 class="pr-4">
          <v-layout column>
            <v-flex>Status :</v-flex>
            <v-flex>
              <v-select
                v-model="config_path.rider_status"
                item-text="name"
                item-value="value"
                :items="rider_status"
                hide-details
              ></v-select>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs3 class="pl-2 pr-4">
          <v-layout column>
            <v-flex>Rider name :</v-flex>
            <v-flex>
              <v-autocomplete
                :loading="fetching_rider"
                :items="rider_list"
                v-model="config_path.rider_id"
                item-text="rider_full_name"
                item-value="rider_id"
                cache-items
                flat
                hide-no-data
                hide-details
              ></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs3 class="pl-2">
          <v-layout column>
            <v-flex>Start :</v-flex>
            <v-flex>
              <v-menu
                :close-on-content-click="false"
                v-model="menu1"
                :nudge-right="-30"
                lazy
                transition="scale-transition"
                offset-y
              >
                <v-text-field
                  v-model="config_path.datetime_start"
                  slot="activator"
                  prepend-icon="event"
                  hide-details
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="config_path.datetime_start"
                  color="#333"
                  no-title
                  @input="menu1 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs3 class="pl-2">
          <v-layout column>
            <v-flex>End :</v-flex>
            <v-flex>
              <v-menu
                :close-on-content-click="false"
                v-model="menu2"
                :nudge-right="-30"
                lazy
                transition="scale-transition"
                offset-y
              >
                <v-text-field
                  v-model="config_path.datetime_end"
                  slot="activator"
                  prepend-icon="event"
                  hide-details
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="config_path.datetime_end"
                  color="#333"
                  no-title
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs1>
          <div class="pt-2 text-xs-center search-btn">
            <v-progress-circular indeterminate color="black" v-if="searching"></v-progress-circular>
            <v-icon large color="black" @click="search()" v-else>search</v-icon>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      searching: false,
      fetching_rider: false,
      rider_status: [
        {
          value: 1,
          name: "Active"
        },
        {
          value: 2,
          name: "Pending"
        },
        { value: 3, name: "Inactive" }
      ],
      rider_list: [{ rider_full_name: "All", rider_id: 0 }],
      menu1: false,
      menu2: false,
      date: new Date().toISOString().substr(0, 10)
    };
  },
  computed: {
    ...mapState({
      config_path: state => state.fetchRiderReport.config_path
    })
  },
  methods: {
    async search() {
      if (this.searching == false) {
        this.searching = true;
        await this.$store.dispatch(
          "fetchRiderReport/getReportRiderList",
          this.config_path
        );
        this.searching = false;
      }
    },
    async fetchRiderList() {
      this.rider_list = [{ rider_full_name: "All", rider_id: 0 }];
      this.fetching_rider = true;
      let fetch_rider_list = await this.$store.dispatch(
        "fetchOrderDetailBack/getDataRider"
      );
      for (let val of fetch_rider_list) {
        this.rider_list.push(val);
      }
      this.fetching_rider = false;
    }
  },
  async created() {
    await this.fetchRiderList();
  }
};
</script>

<style scoped>
.v-text-field {
  padding-top: 0;
  margin-top: 0;
}
.search-btn {
  cursor: pointer;
  height: 50px;
  width: 50px;
  background-color: #ffd300;
  border-radius: 10px;
}
</style>
